// styles/Flex.ts
import styled from 'styled-components';
import { breakpoints } from '../../breakpoints';

export const FlexContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--column-gap);
  width:100%;
`;

interface ColumnProps {
    scaleSmall?: number;
    scaleMedium?: number;
    scaleLarge?: number;
  }

  
  export const FlexColumn = styled.div.withConfig({
    shouldForwardProp: (prop) =>
      !['scaleSmall', 'scaleMedium', 'scaleLarge'].includes(prop)
  })
  <ColumnProps>`
    min-width: min-content;
    flex-shrink: 1;

  /* Large screens */
  @media (min-width: ${breakpoints.minWidthLarge}) {
    flex-grow: ${({ scaleLarge, scaleMedium, scaleSmall }) =>
      scaleLarge ?? scaleMedium ?? scaleSmall ?? 1};
    /* Setting flex-basis to 0 forces columns to share available space rather than sizing based on content */
    flex-basis: 0;
  }

  /* Medium screens */
  @media (min-width: ${breakpoints.minWidthMedium}) and (max-width: ${breakpoints.maxWidthMedium}) {
    flex-grow: ${({ scaleMedium, scaleSmall }) =>
      scaleMedium ?? scaleSmall ?? 0};
    /* If a scale is provided, we use 0; otherwise, fallback to 100% width */
    flex-basis: ${({ scaleMedium, scaleSmall }) =>
      scaleMedium || scaleSmall ? 0 : '100%'};
  }

  /* Small screens */
  @media (max-width: ${breakpoints.maxWidthSmall}) {
    flex-grow: ${({ scaleSmall }) => scaleSmall ?? 0};
    flex-basis: ${({ scaleSmall }) => (scaleSmall ? 0 : '100%')};
  }
`;

export const MedCol50 = styled.div`
    min-width: min-content;
    flex-shrink: 1;

    @media(min-width: ${breakpoints.minWidthMedium})
    {
      flex-basis: calc(50% - (var(--column-gap)/2));
    }
`;
  interface FixedColumnProps {
    width?: string; // e.g. "120px", "10rem"
  }
  
  export const FixedColumn = styled.div<FixedColumnProps>`
    flex: 0 0 auto;
    width: ${({ width }) => width || '100px'};
    min-width: 0;
  `;